import { enqueueSnackbar } from 'notistack';

export function onSuccessEnqueueSnackbar(data: any) {
  if (data?.message) {
    enqueueSnackbar(data.message.toString(), { variant: 'success' });
  }
}
